import api from '../api';

export const notificationService = {
  mine: (params) => api.get('/notifications/mine', { params }),
  // Counted server-side: the badge must not cap at whatever one page returned.
  mineUnreadCount: () => api.get('/notifications/mine/unread-count'),
  markRead: (id) => api.post(`/notifications/${id}/read`),
  markAllRead: () => api.post('/notifications/mine/read-all'),
  remove: (id) => api.delete(`/notifications/${id}`),
  removeAll: () => api.delete('/notifications/mine'),
  logs: (params) => api.get("/notifications/logs", { params }),
  // Google Chat bot (replaces incoming webhooks)
  chatStatus: () => api.get("/notifications/chat/status"),
  chatTest: (body) => api.post("/notifications/chat/test", body || {}),
  chatDmCandidates: () => api.get("/notifications/chat/dm-candidates"),
  mapChatUsers: (mappings) =>
    api.post("/notifications/chat/map-users", { mappings }),
  deferred: (params) => api.get('/notifications/deferred', { params }),
  sendDeferredNow: (id) => api.post(`/notifications/deferred/${id}/send-now`),
  cancelDeferred: (id) => api.post(`/notifications/deferred/${id}/cancel`),
};
